/* global Swiper, attachEvent */
// *******************************************************************************
// Hero Slider
// *******************************************************************************

const heroSliderElements = document.querySelectorAll('[data-slider="hero-slider"]');

const heroSliderOptions = {
  autoplay: {
    delay: 10000,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

heroSliderElements.forEach((el) => {
  const heroSliderParent = el.closest('.sc-hero-slider');
  const paginationElement = heroSliderParent.querySelector('.swiper-pagination');
  const arrowRight = heroSliderParent.querySelector('.arrow-right');
  const arrowLeft = heroSliderParent.querySelector('.arrow-left');

  heroSliderOptions.navigation.nextEl = arrowRight;
  heroSliderOptions.navigation.prevEl = arrowLeft;
  heroSliderOptions.pagination.el = paginationElement;
  // eslint-disable-next-line no-new
  new Swiper(el, heroSliderOptions);
});

// **********************************************************
// Scroll To Next Section
// **********************************************************

attachEvent('.scroll-down', 'click', (ev) => {
  const parentSection = ev.target.closest('.sc-hero-slider');
  clickHandler(parentSection.nextElementSibling.offsetTop);
});
